const API_BASE_URL = process.env.REACT_APP_JSON_SERVER;
export const API_INTG_URL = 'https://supplychain.ddns.net';
console.log("api url",API_INTG_URL)
export default API_BASE_URL
